import { Chip } from "@mui/material";
import { useTranslate } from "react-admin";

import { AccessStatus } from "../../lib/accessStatus";
import { getAccessStatusColor } from "../../lib/statusColors";

export const AccessStatusChip = ({ accessStatus }: { accessStatus: AccessStatus }) => {
  const translate = useTranslate();

  return (
    <Chip
      label={translate(`accessStatus.${accessStatus}`)}
      color={getAccessStatusColor(accessStatus)}
      size="small"
      data-testid={`access-status-${accessStatus}`}
    />
  );
};
